import { RouterReducerState } from '@ngrx/router-store';
import { createSelector } from '@ngrx/store';
import { selectRouterState } from 'src/app/core/core.module';
import { RouterStateUrl } from 'src/app/core/router/router.state';
import { FeaturesState, selectFeatures } from '../features.state';

import { UIState } from './ui-state';

export const selectUIState = createSelector(
  selectFeatures,
  (state: FeaturesState) => state.ui
);

export const selectUIMapChacra = createSelector(
  selectUIState,
  selectRouterState,
  (state: UIState) => state.map.chacra
);

export const selectUIParamsFromURL = createSelector( selectRouterState,
  (urlState: RouterReducerState<RouterStateUrl>) => urlState.state.queryParams
);

export const selectUIParamFromURL = (param: string) => createSelector(
  selectRouterState,
  (urlState: RouterReducerState<RouterStateUrl>) => {
    return getQueryParams(urlState, param);
  }
);

// Funciones auxiliares
function getQueryParams(urlState: RouterReducerState<RouterStateUrl>, key: string, defaul = null) {
  let value = defaul;
  if (urlState) {
    const queryParams = urlState.state.queryParams;
    if (key in queryParams) {
      value = queryParams[key];
    }
  }
  return value;
}
